module.exports = "/packs/arrow_back-09d9103e3a600d1d00cc5a78135597e0.png";